module.exports = __webpack_public_path__ + "img/doc.25ac6f76.svg";